import './index.scss';

import { Component, createRef, ReactNode, RefObject } from 'react';

import ToastsContext, { CreateToastProps } from './context';
import { BraxToast } from '../BraxToast';

export type BraxToastsProps = {
    children: ReactNode
};

type BraxToastsState = {
    toasts: (CreateToastProps & { ref: RefObject<BraxToast> } | null)[]
};

export class BraxToasts extends Component<BraxToastsProps, BraxToastsState> {

    state: BraxToastsState = {
        toasts: []
    };

    left = createRef<HTMLDivElement>();

    right = createRef<HTMLDivElement>();

    create({ onDismiss: _onDismiss, ...toast }: CreateToastProps) {
        let index: number;

        const onDismiss = () => {
            this.setState(prevState => {
                const toasts = [...prevState.toasts];

                if (index !== undefined)
                    toasts[index] = null;

                return { toasts };
            });

            if (_onDismiss)
                _onDismiss();
        };

        this.setState(prevState => {
            const toasts = [...prevState.toasts, { ...toast, ref: createRef<BraxToast>(), onDismiss }];

            index = toasts.length - 1;

            return { toasts };
        });

        return () => this.state.toasts[index]?.ref.current?.dismiss();
    }

    render() {
        return (<>
            <ToastsContext.Provider value={{
                left: this.left,
                right: this.right,
                create: (toast: CreateToastProps) => this.create(toast)
            }}>
                { this.props.children }

                { this.state.toasts.map((toast, index) => toast ? <BraxToast key={index} {...toast} /> : null) }
            </ToastsContext.Provider>

            <div ref={this.left} className="brax-toasts left" />

            <div ref={this.right} className="brax-toasts right" />
        </>);
    }

}
